var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { canUseDOM, isFunction } from '@autobest-ui/utils';
import Queue from './Queue';
import { sendBeacon, ajax } from './sendBeacon';
var ApplicationInsights = /** @class */function () {
  function ApplicationInsights(config, context) {
    this.isBindUnload = false;
    this.timer = null;
    this.config = __assign({
      delay: 5000
    }, config);
    this.context = context;
    // 由于 unload 会销毁实例化的queue，这里使用静态方式，阻止销毁
    ApplicationInsights.queue = new Queue();
    ApplicationInsights.apiUrl = this.config.apiUrl;
    ApplicationInsights.key = this.config.key;
  }
  /**
   * 收集信息
   * @param level 'error' | 'warn' | 'info'
   * @param data 数据
   * @param label 其他信息
   * @param updateId id
   */
  ApplicationInsights.prototype.track = function (level, data, label, updateId) {
    var _a = this.context,
      getContext = _a.getContext,
      extraContext = __rest(_a, ["getContext"]);
    var contextInfo = isFunction(getContext) ? getContext() : {};
    // 加入一些全局信息
    data = __assign(__assign(__assign({}, extraContext), contextInfo), data);
    if (!updateId || !ApplicationInsights.queue.has()) {
      // 这一类为接口， 需要及时收集，对比后端与nginx， 否则时间将无法对齐
      if (level === 'warn') {
        ApplicationInsights._singlePolling(level, data, label);
        return null;
      }
      var id = ApplicationInsights.queue.add(level, data, label);
      this._collectHandle();
      return id;
    }
    return ApplicationInsights.queue.update(updateId, level, data, label);
  };
  /**
   * 对收集的信息进行处理
   * @private
   */
  ApplicationInsights.prototype._collectHandle = function () {
    var _this = this;
    // 只监听一次
    if (canUseDOM && !this.isBindUnload) {
      this.isBindUnload = true;
      window.addEventListener('unload', this._onUnload, false);
    }
    clearTimeout(this.timer);
    // 当收集的信息超过3条，则立刻收集，防止请求时，超出参数范围
    if (ApplicationInsights.queue.has(3)) {
      this._polling();
      return;
    }
    // 延迟收集吗， 防止阻塞UI渲染
    this.timer = setTimeout(function () {
      _this._polling();
    }, this.config.delay);
  };
  /**
   * 调用接口，上传日志信息，并清空已经上传的
   */
  ApplicationInsights._singlePolling = function (level, data, label) {
    ajax(ApplicationInsights.apiUrl, {
      key: ApplicationInsights.key,
      value: JSON.stringify([__assign(__assign({
        level: level
      }, data), {
        label: label
      })])
    });
  };
  /**
   * 调用接口，上传日志信息，并清空已经上传的
   * @private
   */
  ApplicationInsights.prototype._polling = function () {
    clearTimeout(this.timer);
    // 判断是否有信息，没有将不做操作
    if (!ApplicationInsights.queue.has()) {
      return;
    }
    // 这里不用判断是否上传成功，意义不大
    ajax(ApplicationInsights.apiUrl, {
      key: ApplicationInsights.key,
      value: ApplicationInsights.queue.getAll()
    });
    // 清空已经上传的
    ApplicationInsights.queue.removeAll();
  };
  /**
   * unload 后的回调函数，处理剩余的日志信息
   * @private
   */
  ApplicationInsights.prototype._onUnload = function () {
    if (this && this.timer) {
      clearTimeout(this.timer);
    }
    // 判断是否有信息，没有将不做操作
    if (!ApplicationInsights.queue.has()) {
      return;
    }
    sendBeacon(ApplicationInsights.apiUrl, {
      key: ApplicationInsights.key,
      value: ApplicationInsights.queue.getAll()
    });
    // 清空已经上传的
    ApplicationInsights.queue.removeAll();
  };
  ApplicationInsights.queue = null;
  ApplicationInsights.apiUrl = null;
  ApplicationInsights.key = null;
  return ApplicationInsights;
}();
export default ApplicationInsights;